import MuiTypography, { TypographyProps } from '@mui/material/Typography';
import { usePalette } from 'src/hooks';

export const Typography = ({ children, ...props }: TypographyProps) => {
  const { text } = usePalette();

  return (
    <MuiTypography variant='body1' color={text.primary} {...props}>
      {children}
    </MuiTypography>
  );
};
